import axios from "axios";

export const setApplicationConfig = (config) =>{
    return{
        type:'SET_APPLICATION_CONFIG',
        value:config
    }
};

export const setGoUrls = (urls) =>{
    return{
        type : 'SET_GO_URLS',
        value : urls
    }
};

export const setCountryList = (countries) => {
    return {
        type: 'SET_COUNTRY_LIST',
        value : countries
    }
}
export const setConfigCountry = (addressEnabledCountryList) => {
    return {
        type: 'SET_CONFIG_COUNTRY',
        value : addressEnabledCountryList
    }
}
export const setFeatureFlag = (featureflagList) => {
    return {
        type: 'SET_FEATURE_FLAG',
        value : featureflagList
    }
}

export function loadConfig() {

    return function(dispatch) {
        return axios.get(process.env.PUBLIC_URL+'/config.json')
            .then(res => {
                let hostName = window.location.hostname;
                if(res && res.data && res.data.services.length){
                    if(hostName.indexOf('helpx.adobe.com') >=0){
                        dispatch(setApplicationConfig(res.data.services[1]));
                    }else{
                        dispatch(setApplicationConfig(res.data.services[0]));
                    }
                   dispatch(setGoUrls(res.data.goUrls));
                   dispatch(setCountryList(res.data.countries));
                   dispatch(setConfigCountry(res.data.addressEnabledCountryList));
                }
            })
            .catch(function (error) {
                console.log('Error while loading config');
            });
    };
}
